module.exports = __webpack_public_path__ + "img/6.6f3484e5.jpg";